import { getConfig } from '@/config'

/**
 * Resolve a path or relative URL to an absolute URL for social crawlers.
 */
export function resolveAbsoluteUrl(url: string): string {
  if (!url) return ''
  if (/^https?:\/\//i.test(url)) return url

  const config = getConfig()
  const base = (
    config.api?.appUrl ||
    (typeof window !== 'undefined' ? window.location.origin : '') ||
    ''
  ).replace(/\/$/, '')

  if (!base) return url

  return `${base}${url.startsWith('/') ? url : `/${url}`}`
}
